var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3406_85581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 19.9995V12.6746C19.9993 9.0747 19.2243 6.32475 15.0244 6.32475C12.9994 6.32475 11.6494 7.42473 11.0994 8.47471H11.0494V6.64975H7.07452V19.9995H11.2244V13.3746C11.2244 11.6246 11.5494 9.94968 13.6994 9.94968C15.8244 9.94968 15.8494 11.9246 15.8494 13.4746V19.9745H19.9993V19.9995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.324402 6.65027H4.47432V20H0.324402V6.65027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.39995 0C1.07498 0 0 1.07498 0 2.39995C0 3.72493 1.07498 4.82491 2.39995 4.82491C3.72493 4.82491 4.79991 3.72493 4.79991 2.39995C4.79991 1.07498 3.72493 0 2.39995 0Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3406_85581"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.d5dddb346d6a2aa47ba77840248c0526.svg";
export { ForwardRef as ReactComponent };